import axios from "axios";
import JwtService from "@/core/services/jwt.service";
import { app } from "@/main";
import store from "@/core/services/store";
import { LOGOUT } from "@/core/services/store/auth.module";

// 创建axios实例
const service = axios.create({
  // 同源相对路径：请求打到站点自身的 /api/*，由 nginx 反代到后端。
  // 不用构建期环境变量区分环境 —— 同一个构建产物要同时部署到 staging 与 prod
  // (fleet Model 2 交付),环境差异必须落在 nginx 那一层,不能烤进制品。
  // 注:各 api 模块的 url 必须以 / 开头,否则会被解析成相对当前页面路径。
  baseURL: "",
  timeout: 8000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 不能写成 if (`${JwtService.getToken()}`) —— 模板字符串把 null 变成字符串 "null"，
    // 判断恒真，未登录时也会往后端发一个 x-token: null 的头。
    const token = JwtService.getToken();
    if (token) {
      config.headers["x-token"] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非0是抛错 可结合自己业务进行修改
     */
    const res = response.data;

    if (res.code >= 300) {
      app.$bvToast.toast("code: " + res.code, {
        title: res.message,
        variant: "danger",
        toaster: "b-toaster-top-center",
      });
      // 401:非法的token; 10009:Token 过期了;  10010: 找不到 Token;
      if (res.code === 401 || res.code === 10009 || res.code === 10010) {
        app.$bvModal
          .msgBoxConfirm("你已被登出，可以取消继续留在该页面，或者重新登录。", {
            title: "确定登出",
            okVariant: "warning",
            okTitle: "重新登录",
            cancelTitle: "取消",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          })
          .then(() => {
            store.dispatch(LOGOUT).then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          });
      }
      return Promise.reject("error");
    } else {
      if (response.status === 201) {
        app.$bvToast.toast("创建成功", {
          title: "",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
      }
      if (response.status === 204) {
        app.$bvToast.toast("删除成功", {
          title: "",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
      }
      return response.data;
    }
  },
  (error) => {
    app.$bvToast.toast("", {
      title: error.response.data.message,
      variant: "danger",
    });
    return Promise.reject(error);
  }
);

export default service;
